<template>
  <div>
    <div class="pa-1">
      <v-layout>
        <v-flex xs6>
          <div style="font-size: 16px; font-weight: 600" class="mb-3 primary--text">
            {{ $t('Best seller') }}
          </div>
        </v-flex>
        <v-flex xs6 style="display: flex; justify-content: flex-end">
          <v-pagination
            :total-visible="6"
            v-model="pageNumber"
            @input="changePage"
            :length="pagelength"
          ></v-pagination>
        </v-flex>
      </v-layout>

      <template>
        <v-data-table :headers="headers" :items="data" hide-actions>
          <template v-slot:items="props">
            <tr>
              <td class="text-center">{{ (pageNumber - 1) * limit + (props.index + 1) }}</td>
              <td class="text-center">{{ props.item.name }}</td>
              <td class="text-center">{{ props.item.count }}</td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'

export default {
  props: ['selectedDate'],
  data: function () {
    return {
      loading: false,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      data: [],
      headers: [
        { text: 'No.', value: 'no', align: 'center', sortable: false },
        { text: 'Product Name', value: 'product_name', align: 'center', sortable: false },
        { text: 'Quantity', value: 'quantity', align: 'center', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    moment() {
      return moment
    },
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted: function () {
    this.getBestSeller()
  },
  methods: {
    getBestSeller() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid, // required
        start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
        end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD'),
        limit: vm.limit,
        offset: vm.offset
      }
      vm.loading = true
      api.getLamySaleReportBestSeller(data, (err, response) => {
        if (response.responsecode == 200) {
          vm.data = response.data
          vm.total = response.total
          vm.loading = false
        } else {
          console.log(err)
          return
        }
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getBestSeller()
      }
    }
  },
  watch: {
    loading: function () {},
    selectedDate: {
      handler: function (newValue) {
        this.getBestSeller()
      },
      deep: true
    }
    // filter: function() {

    // }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/PurchaseBehavior/BestSeller.vue